import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import MuiButton from "Components/MuiButton/MuiButton";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { DialogActions } from "@material-ui/core";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import * as Icons from "react-bootstrap-icons";
import ListTemplate from "./list";
import NewTemplate from "./New";

export default function TemplateIndex({ row }) {
  const { direction } = useTheme();
  const [openDialog, setOpenDialog] = useState(false);
  const [reget, setReget] = useState(false);

  const handleDialog = () => setOpenDialog(!openDialog);

  const onExit = () => {
    setOpenDialog(false);
  };

  const onChangeList = (value) => {
    setReget(value);
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="patternListInGroup" />}
        icon={<Icons.ListTask size={17} />}
        className="warning-fill"
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{ onExit: onExit }}
        onClose={handleDialog}
        fullWidth
        maxWidth="md"
      >
        <div>
          <div className="dialogHeader">
            <p>{<Translator id={"patternListInGroup"} />}</p>
          </div>
          <DialogContent id="content-dialog-manager">
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                className="text-center py-2 mb-3"
                style={{ backgroundColor: "#E4E8E8" }}
              >
                <strong>
                  <Translator id="newPattern" noSpan />
                </strong>
              </Grid>
              <NewTemplate
                row={row}
                onEnter={openDialog}
                onChangeList={onChangeList}
              />
              <Grid
                item
                xs={12}
                className="text-center mt-4 mb-2"
                style={{ backgroundColor: "#E4E8E8" }}
              >
                <strong>
                  <Translator id="patternListInGroup" noSpan />
                </strong>
              </Grid>
              <Grid container>
                <Grid item xs={12}>
                  <ListTemplate row={row} onEnter={openDialog} reget={reget} />
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
}
